jQuery(document).ready(function($){

    $(window).resize(function(){
        adjustMainMargin();
    })
    adjustMainMargin();

    function adjustMainMargin(){
        
        var header_height = $('header').outerHeight();

        if($('body').hasClass('page-template-home')){
            return
        }
        else {

            $('main').css('margin-top', header_height+'px');

        }
    }


    $('.reviews-slider').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        slidesToScroll: 1,
        prevArrow: '<i class="slick-arrow left fas fa-chevron-left"></i>',
        nextArrow: '<i class="slick-arrow right fas fa-chevron-right"></i>',
    });



    $(document).on('click', '.custom-add-to-cart-button', function(){

        

        var product_id = $(this).data('product-id');

        ThemeJS.Functions.send_ajax_request({

            data: {
                action: 'custom_add_to_cart',
                'product_id': product_id,
   
            },
            success: ( data ) => {
                console.log(data);

                window.location.href =  data.cart_url;

            },
            error: ( data ) => {
            }
        });
    });


    $('.search-toggle').click(function(){

        $('.desktop-search-container').toggleClass('show');

    });

    $('.exit-search').click(function(){
        $('.desktop-search-container').toggleClass('show');
    });


    $('.ginput_container_select, .ginput_container_radio, .ginput_container_checkbox').closest('.gfield').find('.gfield_label').addClass('show');


    


    checkCompaniesSliderInit();

    $(window).resize(function(e){
        checkCompaniesSliderInit();
    });

    function checkCompaniesSliderInit(){
        if(window.innerWidth < 768) {
            if(!$('.companies-students-work-for-slider').hasClass('slick-initialized')){
                mobileOnlySliderCompanies();
            }
    
        }else{
            if($('.companies-students-work-for-slider').hasClass('slick-initialized')){
                $('.companies-students-work-for-slider').slick('unslick');
            }
        }
    }

    function mobileOnlySliderCompanies(){
            $('.companies-students-work-for-slider').slick({
                dots: false,
                infinite: true,
                slidesToShow: 1,
                // variableWidth: true,
                autoplay: false,
                slidesToScroll: 1,
                prevArrow: '<i class="slick-arrow left fas fa-chevron-left"></i>',
                nextArrow: '<i class="slick-arrow right fas fa-chevron-right"></i>',
            });

    }


});

